import { useCallback, useEffect, useState } from 'react';

interface IProps {
	defaultValue: number;
	onChange?: (value: number) => void;
	readonly?: boolean;
}

export const Stars = ({ defaultValue, onChange, readonly = false }: IProps) => {
	const [value, setValue] = useState<number>(defaultValue);

	useEffect(() => {
		if (readonly && defaultValue !== value) {
			setValue(defaultValue);
		}
	}, [defaultValue, setValue, readonly, value]);

	const onClick = useCallback(
		(val: number) => {
			if (readonly) {
				return;
			}

			setValue(val);

			if (onChange) {
				onChange(val);
			}
		},
		[setValue, onChange, readonly]
	);

	const stars = [];
	for (let i = 1; i <= Math.min(value, 5); i++) {
		// eslint-disable-next-line react/jsx-no-bind
		stars.push(<span className={'fa fa-star-stroke set'} key={i} onClick={() => onClick(i)}></span>);
	}

	for (let i = value + 1; i <= 5; i++) {
		// eslint-disable-next-line react/jsx-no-bind
		stars.push(<span className={'fa fa-star-stroke'} key={i} onClick={() => onClick(i)}></span>);
	}

	return (
		<div className="stars d-flex nowrap">
			<span className="stars-wrapper">{stars.map((element) => element)}</span>
		</div>
	);
};
